const Data = [
    {
        name: "Suchismita Sahoo",
        position: "Media and Design Head",
        imageUrl: "/assets/images/members/Heads24/Suchismita Sahoo.jpg",
        facebookLink: "https://www.facebook.com/profile.php?id=61550090230775",
        linkedinLink: "https://www.linkedin.com/in/suchismita-s-5282072ab?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
        email: "suchismita.sahoo@gyws.org"
    },
    {
        name: "Akshat Verma",
        linkedinLink: "http://www.linkedin.com/in/akshatvermaa",
        email: "akshat.verma@gyws.org",
        imageUrl: "/assets/images/members/Heads24/Akshat Verma.jpg",
        position: "SRC and Media Head"
      },
      {
        name: "Anmol Singh",
        position: "Media Head",
        imageUrl: "/assets/images/members/Heads24/Anmol Singh.jpeg",
        facebookLink: "https://m.facebook.com/profile.php?id=100007010851430",
        linkedinLink: "https://www.linkedin.com/in/anmol-singh-55025b259?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
        email: "anmol.singh@gyws.org"
    },
    {
        "name": "Ananya Sikdar",
        "position": "Media Head",
        "imageUrl": "/assets/images/members/Heads24/AnanyaSikdar.jpg",
        "facebookLink": "https://www.facebook.com/profile.php?id=61560681846015&mibextid=JRoKGi",
        "linkedinLink": "https://in.linkedin.com/comm/in/ananya-sikdar-82b20a26b?lipi=urn%3Ali%3Apage%3Aemail_email_notification_single_search_appearance_01%3BbvXvgqYETD2khDOmKg4LDQ%3D%3D&midToken=AQGvP01H2NSctg&midSig=0WGYCAVpGGQXg1&trk=eml-email_notification_single_search_appearance_01-header-0-profile_glimmer&trkEmail=eml-email_notification_single_search_appearance_01-header-0-profile_glimmer-null-ibv28z~lx35ws27~t6-null-null&eid=ibv28z-lx35ws27-t6&otpToken=MTMwNDFlZTgxMTJmY2ZjNWJkMmIwZmViNDExZmUwYjI4OGNjZDk0MzlhYWY4NzY4N2JjZjA1Njc0NjViNThmMWZmZDdkNGU5NTBkMmM3ODE1NDkyZDQ5YzQ4ZjI2NWE4YzE3NzljZDA2ZDc3MDNjNTc5YTAzNmE4LDEsMQ%3D%3D",
        "email": "ananya.sikdar@gyws.org"
    },
]

export default Data;